<template>
  <div>
    The constellation optimization mission can optimise on different performance
    metrics:
    <ul>
      <li>
        <b>Average revisit time</b>: maximises the number of points of interest
        seen by the constellation while reducing the average revisit time.
      </li>
      <li>
        <b>Maximum revisit time</b>: maximises the number of points of interest
        seen by the constellation while reducing the maximum revisit time.
      </li>
      <li>
        <b>Number of satellites</b>: maximises the number of points of interest
        seen by the constellation while minimizing the number of satellites
        needed to obtain a maximum revisit time below a given threshold.
      </li>
      <li>
        <b>Number of planes</b>: maximises the number of points of interest seen
        by the constellation while minimizing the number of planes needed to
        obtain a maximum revisit time below a given threshold.
      </li>
      <li>
        <b>Semi major axis</b>: maximises the number of points of interest seen
        by the constellation while minimizing the semi major axis needed to
        obtain a maximum revisit time below a given threshold.
      </li>
      <li>
        <b>Custom</b>: creates a combination of the previously listed goals by
        setting a weight to each of them.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationOptimizationGoals'
}
</script>
